var _style, _rect, _path, _path2, _path3, _path4, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 176,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 176 57",
    style: {
      enableBackground: "new 0 0 176 57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 176,
    height: 57
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5785,
    y1: 80.1142,
    x2: 55.9364,
    y2: -38.0063,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3552,
    style: {
      stopColor: "#20DB93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    style: {
      stopColor: "#2893F0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.8,6.8l10.5,6h0l5.9-3.4L27.8,0L11.4,9.5l5.9,3.4L27.8,6.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -6.8319,
    y1: 81.2608,
    x2: 29.2574,
    y2: -29.8736,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3552,
    style: {
      stopColor: "#20DB93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    style: {
      stopColor: "#2893F0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.4,23.1l-5.9-3.4v19l16.4,9.5v-6.8l-10.5-6.1V23.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.922,
    y1: 64.2227,
    x2: 53.8825,
    y2: -12.6413,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3552,
    style: {
      stopColor: "#20DB93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    style: {
      stopColor: "#2893F0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.3,35.3l-10.5,6.1v6.8l16.4-9.5v-19l-5.9,3.4V35.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.7267,
    y1: 85.5497,
    x2: 49.9537,
    y2: -22.9293,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3552,
    style: {
      stopColor: "#20DB93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    style: {
      stopColor: "#2893F0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.3,10.8C55.3,10.8,55.3,10.8,55.3,10.8c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.2-0.3-0.4-0.4-0.6c0,0,0,0,0,0 C54,8.8,53.4,8.3,52.7,8c-1.6-0.8-3.6-0.8-5.2,0.1c-0.9,0.5-1.6,1.2-2,2.1c-0.4,0.7-0.6,1.6-0.7,2.4l-3.5,2v0l-7.5,4.3l-3,1.7h0 l-3,1.7l-3-1.7c0,0,0,0,0,0l-3-1.7l-7.5-4.3v0l-3.5-2c0-0.8-0.3-1.7-0.7-2.4c-0.5-0.8-1.1-1.6-2-2.1C6.5,7.1,4.6,7.2,3,8 C2.3,8.3,1.6,8.8,1.1,9.5C1,9.7,0.9,9.9,0.7,10.1c-0.1,0.2-0.2,0.4-0.3,0.7c0,0,0,0,0,0C0.1,11.5,0,12.3,0,13.1c0,0,0,0,0,0 c0.1,1.8,1.1,3.5,2.7,4.5c0.9,0.5,1.8,0.7,2.8,0.7c0.9,0,1.7-0.2,2.4-0.6h0l3.5,2L19,24l2.9,1.7l3,1.7v3.4v0v3.4V43V47 c-0.7,0.5-1.3,1.1-1.8,1.9c-0.5,0.8-0.7,1.7-0.7,2.7c0,1.9,1,3.6,2.5,4.6c0.7,0.4,1.4,0.7,2.2,0.8c0.2,0,0.5,0.1,0.7,0.1 c0.2,0,0.5,0,0.7-0.1c0.8-0.1,1.6-0.4,2.2-0.8c1.5-1,2.5-2.7,2.5-4.6c0-1-0.3-1.9-0.7-2.7c-0.4-0.8-1-1.4-1.8-1.9V43v-8.8v-3.4v-3.4 l3-1.7l3-1.7l7.6-4.4l3.5-2h0c0.8,0.4,1.6,0.6,2.4,0.6c0.9,0,1.9-0.2,2.8-0.7c1.7-1,2.6-2.7,2.7-4.5c0,0,0,0,0,0 C55.7,12.3,55.6,11.5,55.3,10.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M85.5,33.4l-0.1,3.1H68.2V13.8h16.6l0.1,3.1H71.7v6.5H83v2.7H71.7v7.3H85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.8,13.8l7.9,16.2l1,2.2h0.1l1-2.2l7.9-16.2h3.9v22.7h-3.2V21.4l0.1-2.4l-0.1,0l-1,2.2l-7.5,15.4h-2.5 L95,21.2l-1-2.2l-0.1,0l0,2.4v15h-3.1V13.8H94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.1,26.6l7,9.9h-4.2l-5.9-9.2h-5.7v9.2h-3.5V13.8h9.3c5.6,0,8.3,2.3,8.3,6.6 C141.3,23.8,139.5,26.1,136.1,26.6z M133,16.7h-5.8v7.9h5.6c3.4,0,4.9-1.2,4.9-4.1C137.7,17.9,136.3,16.7,133,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M147.9,13.8h3.6v22.7h-3.6V13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.6,17v19.5h-3.5V17h-8l0.1-3.2h19.4l0.1,3.2H167.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d2e83d9e.svg";
export { ForwardRef as ReactComponent };